import React from "react";
import { Link } from "react-router-dom";
import OrderSuccessimg from "../../src/assets/images/orders_success.png";
import OrderFailedimg from "../../src/assets/images/payment_failed_img.png";
import { useLocation } from "react-router-dom";
import Image1 from "../../src/assets/images/group.png";
import { useState, useEffect } from "react";
function OrderSuccesspage() {
  const [orderId, setOrderId] = useState(null);
  const [orderStatus, setOrderstatus] = useState(null);
  const [transcationid, setTranscationid] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("order_id");
    const orderstatus = urlParams.get("status_id");
    const transaction_id = urlParams.get("transaction_id");
    const messages = urlParams.get("msg");

    const formatedmessage = messages ? messages.replace("/_/g", " ") : "";

    setOrderId(id);
    setOrderstatus(orderstatus);
    setTranscationid(transaction_id);
    setMessage(formatedmessage);
  }, []);

  return (
    <section className="order_success_page pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="inner-box text-center">
              {orderStatus == 1 ? (
                <>
                  <img src={OrderSuccessimg} alt="img" />
                </>
              ) : (
                <>
                  <img
                    src={OrderFailedimg}
                    style={{ width: "50%" }}
                    alt="img"
                  />
                </>
              )}

              {orderStatus == 1 ? (
                <>
                  <h4 style={{ color: "#374706" }}>Order Successful!</h4>
                </>
              ) : (
                <>
                  <h4 style={{ color: "red" }}>Payment Failed</h4>
                </>
              )}

              <p className="text-center">{message ? <>{message}</> : null}</p>
              <h6 className="text-center">
                Order ID: {orderId ? <>{orderId}</> : null}
              </h6>
              <h6 className="text-center">
                Transcation ID: {transcationid ? <>{transcationid}</> : null}
              </h6>
              <div className="btn_box">
                <Link to="/"> Go to home page</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OrderSuccesspage;
